import { PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js";
import { Skeleton } from "antd";
import React, { useEffect } from "react";
import { createSubscriptionPaypal } from "../../utils/Api/payPalServices";
import { useNavigate } from "react-router-dom";

const Checkout = ({ currentUser, idPlan, state }) => {
  const [{ options, isPending }, dispatch] = usePayPalScriptReducer();
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      dispatch({
        type: "resetOptions",
        value: {
          ...options,
          intent: "subscription",
        },
      });
    }, 100);
  }, []);

  const SaveDataSubscription = (data:{
    orderID: string;
    subscriptionID: string;
    facilitatorAccessToken: string;
    paymentSource: string;
  }) => {
    const values = {
      id: data.subscriptionID,
      player_id: currentUser.id_player,
      start_subscription: new Date(),
      reason: state?.subscriptionName,
      data: [data],
      updateType: 'subscription',
      recurring_type: state?.subscriptionFrequency,
    };
    console.log("Que valores envio a la api", values);

    createSubscriptionPaypal(values)
      .then((resp) => {
        console.log("Respuesta de createSubscriptionPaypal", resp);
        const result = resp.data;
        if (resp.status === "ok") {
          navigate("/finishPayment", {
            state: {
              suscriptionData: {
                subscriptionName: state.subscriptionName,
                currency: "CLP",
                amount: state.subscriptionAmount,
                frequency_type: state.subscriptionFrequency,
                start_date: result.start_subscription,
                next_payment: result.next_payment_date,
              },
              isSuccess: true,
              isProccessing: false,
            },
          });
        }
      })
      .catch((error) => {
        console.log("error al crear la suscripción", error);
        navigate("/finishPayment", {
          state: {
            suscriptionData: {},
            isSuccess: false,
            isProccessing: false,
          },
        });
      });
  };

  const onCreateOrder = async (data, actions) => {
    return actions.subscription
      .create({
        plan_id: idPlan,
      })
      .then((orderId) => {
        return orderId;
      });
  };

  const onApproveOrder = (data, actions) => {
    console.log('Que valores envio a la api', data);
    SaveDataSubscription(data);
    return actions.order;
  };
  return (
    <div className="flex flex-col w-full p-4 mt-4 bg-gray-100 rounded-md">
      {isPending ? (
        <div className="flex flex-col w-full p-4 mt-4 bg-gray-100 rounded-md">
          <Skeleton.Button active size="large" block className="mb-4" />
          <Skeleton.Button active size="large" block className="mb-4" />
        </div>
      ) : (
        <>
          <div className="mt-3">
            <PayPalButtons
              style={{
                layout: "vertical",
                label: "subscribe",
                color: "blue",
                shape: "pill",
                tagline: false,
              }}
              createSubscription={(data, actions) =>
                onCreateOrder(data, actions)
              }
              onApprove={(data, actions) => onApproveOrder(data, actions)}
            />
          </div>
        </>
      )}
    </div>
  );
};
export default Checkout;
